
import { mapState } from 'vuex';
import AppAiIcon from '@/components/core/AppAiIcon';
import AiIconType from '@/enums/AiIconType';

export default {
  name: 'ReviewAskEntryCardMobile',
  components: { AppAiIcon },
  props: {
    presets: { type: Array, default: () => [] },
    reviewsCount: { type: Number, default: null }
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    isGradientAiIconType() {
      return this.reviewSettings.ai_icon_type === AiIconType.GRADIENT;
    },
    pointColorStyle() {
      return {
        '--review-ask-point-color': this.reviewSettings.main_color || null
      };
    },
    subtitleText() {
      const count = this.reviewsCount || 0;
      return this.$t('review_ask.entry.subtitle', [count.toLocaleString()]);
    }
  },
  methods: {
    openPreset(preset, event) {
      this.$emit('open', {
        question: preset,
        targetElement: event.currentTarget
      });
    },
    openDirect(event) {
      this.$emit('open', {
        question: null,
        targetElement: event.currentTarget
      });
    }
  }
};
